module.exports = __webpack_public_path__ + "img/button_info_questionmark.e390672a.svg";